import clsx from 'clsx'

import { type InspectorContent as InspectorContentType } from '../../../../../shared/types'
import { normalizeImageName } from '../../../../../shared/utils'
import { parentMeta } from '../../type'
import styles from './InspectorContent.module.scss'
import useInspectorContent from './useInspectorContent'
import Vignette from '../../../../common/Vignette/Vignette'
import { Typography } from '@mui/material'
import { Copy, CopyContainer } from '../../../../common/copy'

interface InspectorContentProps {
  parentMeta?: parentMeta
  content: InspectorContentType
  filePath?: string
}

const InspectorContent = (props: InspectorContentProps) => {
  const { parentMeta, filePath, content } = props

  const { files } = content

  const { activeImgSrc, zoom, handlers, disabled } = useInspectorContent({
    files,
  })

  const vignetteImg = (src: string) => {
    return (
      <Vignette
        darkCorner="random"
        darkCornerSize="small"
        size="large"
        key={src}
      >
        <div
          className={clsx(styles.imgContainer, zoom && styles.zoom)}
          onClick={handlers.handleNext} // chat: how do i disable this when diabled === true?
        >
          <img src={`${filePath}${src}`} alt={normalizeImageName(src, true)} />
        </div>
      </Vignette>
    )
  }

  let children
  if (!files?.length) {
    return (
      <CopyContainer padding="medium">
        <Typography color="error">
          Error loading inspector: missing files
        </Typography>
      </CopyContainer>
    )
  } else if (disabled && files?.length) {
    // if disabled, no zooming, and show all images
    children = files.map((imgSrc) => vignetteImg(imgSrc))
  } else {
    // use as intented: show the active image with click->zoom->next
    children = vignetteImg(activeImgSrc)
  }

  return <div className={styles.inspectorContentRoot}>{children}</div>
}

export default InspectorContent
